import { Injectable } from "@angular/core";
import { SessionService } from "../../../../core/storage/session.service";
import { GridStateService } from "../../../../shared/grid/grid-state.service";
import { ADDRESS_CHASE_GRID } from "../../member/chase-detail/chase-detail-chart/attributes";

// Owned here (rather than in the Pends component) so this service doesn't import from a
// component that in turn imports this service, which would create a circular dependency.
export const ADDRESS_PEND_GRID = "AddressPendGrid";

interface IPendGridMeta {
  addressId: number;
  sortField: string;
  sortOrder: number;
}

// Owns the AID Chase/Pend grid-state session keys and their per-address staleness marker
// convention in one place, so clearing/checking them doesn't need to be reimplemented per grid.
@Injectable()
export class AidGridStateService {
  static readonly CHASE_GRID_KEY = ADDRESS_CHASE_GRID.attributeCode;
  static readonly PEND_GRID_KEY = ADDRESS_PEND_GRID;
  private readonly PEND_META_KEY = "GRID_AddressPendGridMeta";

  constructor(
    private readonly gridStateService: GridStateService,
    private readonly session: SessionService
  ) { }

  clearChaseStateIfStale(addressId: number): void {
    const state = this.gridStateService.get(AidGridStateService.CHASE_GRID_KEY);
    const savedAddressId = state?.request?.filters?.find(filter => filter.key === "DocumentSourceId")?.input?.value;
    if (state != null && savedAddressId !== addressId?.toString()) {
      this.gridStateService.delete(AidGridStateService.CHASE_GRID_KEY);
    }
  }

  clearPendStateIfStale(addressId: number): void {
    const state = this.gridStateService.get(AidGridStateService.PEND_GRID_KEY);
    const savedAddressId = this.getPendMeta()?.addressId;
    if (state != null && savedAddressId !== addressId) {
      this.gridStateService.delete(AidGridStateService.PEND_GRID_KEY);
      this.session.delete(this.PEND_META_KEY);
    }
  }

  clearAll(): void {
    this.gridStateService.delete(AidGridStateService.CHASE_GRID_KEY);
    this.gridStateService.delete(AidGridStateService.PEND_GRID_KEY);
    this.session.delete(this.PEND_META_KEY);
  }

  savePendMeta(addressId: number, sortField: string, sortOrder: number): void {
    this.session.put(this.PEND_META_KEY, { addressId, sortField, sortOrder });
  }

  getPendMeta(): IPendGridMeta {
    return this.session.get<IPendGridMeta>(this.PEND_META_KEY, null);
  }
}
